import '@babel/polyfill';
import '@babel/plugin-syntax-dynamic-import';
import * as conditioner from 'conditioner-core/conditioner-core.min';

import { gsap } from "gsap";
import barba from '@barba/core';

// OneTrust Cookies Consent
ParamsData.oneTrust_id && import('./modules/onetrust').then(module => module.Onetrust());

// MarkerIo bugReports
ParamsData.bug_report_id && import('./modules/bugReport').then(module => module.bugReport());

const datalayer = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'dataLayer.ready'
    })
}

// Conditioner
conditioner.addPlugin({
    // the plugin "monitor" hook
    // use in html : <div data-module="modules/component.js" data-context="@visible true"></div>
    monitor: {
        // the name of our monitor, not prefixed with "@"
        name: 'visible',

        // the monitor factory method, this will create our monitor
        create: (context, element) => ({
            // current match state
            matches: false,

            // called by conditioner to start listening for changes
            addListener(change) {
                new IntersectionObserver((entries) => {
                    // update the matches state
                    this.matches = entries.pop().isIntersecting === context;

                    // inform conditioner of the new state
                    change();
                }).observe(element);
            },
        }),
    },

    // converts module aliases to paths
    moduleSetName: (name) => `./modules/${name}.js`,

    // get the module constructor
    moduleGetConstructor: (module) => module.default,

    // override the import (this makes webpack bundle all the dynamically included files as well)
    // https://webpack.js.org/api/module-methods/#import-
    // - set to "eager" to create a single chunk for all modules
    // - set to "lazy" to create a separate chunk for each module
    moduleImport: (name) => import(/* webpackMode: "lazy" */ `${name}`),
});

// conditioner.hydrate(document.documentElement);

const timeline = gsap.timeline();
window.addEventListener("load", () => {
    barba.init({
        debug: true,
        transitions: [
        // default
        {
            async leave() {
                timeline
                    .to(document.body, { opacity: '0', duration: 0.5 });
                const done = this.async();
                await delay(1000);
                done();
            },
            enter() {
            },
            once() {
                datalayer();
                conditioner.hydrate(document.documentElement);
                timeline.to(document.body, { opacity: '1', duration: 0.5 });
            }
        }
        ]
    });

    barba.hooks.after(() => { 
        conditioner.hydrate(document.documentElement);
       
    });

    barba.hooks.leave(() => {
    });

    barba.hooks.enter(() => {
        datalayer();
        window.scrollTo(
            {
                top: 0,
                left: 0,
                behavior: "instant"
            }
        );

        timeline.to(document.body, { opacity: '1', duration: 0.3 });
    })
})

function delay(n) {
    return new Promise((done) => {
        setTimeout(() => {
            done();
        }, n)
    })
}